import React from "react";
import { Col, ControlLabel, Panel, Row, Table } from "react-bootstrap";

const StatisticsContent = ({ statistics }) => {
    return (
        <>
            <Row className="col-sm-5th">
                <Col sm={1}>
                    <Panel className="statistic-counter-value">
                        <Panel.Heading>Отправлено писем</Panel.Heading>
                        <Panel.Body>{statistics?.totalSent || 0}</Panel.Body>
                    </Panel>
                </Col>
                <Col sm={1}>
                    <Panel className="statistic-counter-value">
                        <Panel.Heading>Открыто писем</Panel.Heading>
                        <Panel.Body>{statistics?.totalOpened || 0}</Panel.Body>
                    </Panel>
                </Col>
                <Col sm={1}>
                    <Panel className="statistic-counter-value">
                        <Panel.Heading>Open rate</Panel.Heading>
                        <Panel.Body>{statistics?.clickRate || 0}%</Panel.Body>
                    </Panel>
                </Col>
            </Row>
            <br/>
            <ControlLabel>Кнопки:</ControlLabel>
            <Table>
                <thead>
                    <tr>
                        <th>Название кнопки</th>
                        <th>Кол-во кликов</th>
                        <th>Click rate %</th>
                    </tr>
                </thead>
                <tbody>
                    {statistics?.buttons?.map((button, index) => (
                        <tr key={`button-${index}`}>
                            <td>{button.buttonName}</td>
                            <td>{button.counter}</td>
                            <td>{button.clickRate}</td>
                        </tr>
                    ))}
                </tbody>
            </Table>
        </>
    );
};

export default StatisticsContent;
